import React from 'react'
import McAfeeFooter from '../../components/docomo/McAfeeFooter.js'
import McAfeeHeader from '../../components/docomo/McAfeeHeader.js'
import { 
    Card, 
    Col,
    Row,
    Grid,
    Body ,
    Divider, 
    Link
} from '@mcafee/pegasus'
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";
import { HTTPStatus } from '../../utils/enum.js';

export default function CreateSubscription() {
    const navigate = useNavigate();
    const location = useLocation();
    const { docomoId, signature, isRestartSubscription } = location.state || {};
    const handleClick = (url, w_width, w_height) => {
        const features = `width=${w_width},height=${w_height},noopener,noreferrer`;
        window.open(url,'_blank',features);
    };
    const [isDisabled, setIsDisabled] = React.useState(false);
    const handleCreateSubscription = async () => {
        // This function would typically handle the creation of a subscription.
        try {
            setIsDisabled(true);
            const baseUrl = process.env.REACT_APP_PARTNER_PAGES_BACKEND_URL;
            const response = await axios.post(`${baseUrl}/docomo/createSubscription`, {docomoId: docomoId, signature: signature, isRestartSubscription: isRestartSubscription});
            if (response.status === HTTPStatus.OK) {
                // Handle successful subscription creation, e.g., redirect to a confirmation page
                navigate('/DisplaySupportId', {
                    state: { 
                        supportId: response.data.data.supportId, 
                        cust_context_id: response.data.data.cust_context_id,
                        signedAt: response.data.data.signedAt,
                        signedCCID: response.data.data.signature
                    }   
                })
            }
            else {
                navigate(`/Login?errorCode=${encodeURIComponent('M-000')}`)
            }
        } catch (error) {
            // Handle error in subscription creation
            console.error("Error creating subscription:", error);
            // redirect to error page
            navigate(`/Login?errorCode=${encodeURIComponent('M-000')}`)
        }
    }
    
  return (
      <>
      <title>パソコン向けウイルス対策とインターネット セキュリティ | マカフィー</title>
          <div>
              <header className="App-header">
                  <McAfeeHeader />
              </header>
              <main>
                  <section>
                      <div className="bg-primary corner-xl bg-size-auto">
                          <Grid >
                              <Row center="xs">
                                  <Col>
                                      <Card className="py-72" featured >
                                          <Grid>
                                              <Row center="xs" className="pb-40" >
                                                  <Col>
                                                      <Body level="1">
                                                          <div center="xs">
                                                              PCセキュリティpowered by McAfeeログインページ 
                                                          </div> <br/>
                                                      </Body>
                                                  </Col>
                                              </Row>                                               
                                                  <Divider className="mb-24" />
                                              <Row>
                                                <Col>
                                                  <Body level="4" className="flex align-items-center" >
                                                    <p className="text-left px-24">
                                                      下の [同意して登録する] をクリックすると、
                                                      <Link
                                                        className="text-danger"
                                                        onClick={() => handleClick('https://www.mcafee.com/ja-jp/consumer-support/policy/legal.html#eula','650', '650')}
                                                      >
                                                        マカフィー使用許諾条件
                                                      </Link>
                                                      &nbsp;と&nbsp;
                                                      <Link
                                                        className="text-danger" 
                                                        onClick={() => handleClick('https://www.mcafee.com/?csrc=vanity', '1075', '750')}
                                                      >
                                                        プライバシー ポリシー
                                                      </Link>
                                                      に同意したものと見なされます。
                                                    </p>
                                                  </Body>
                                                </Col>
                                              </Row>
                                              <br />
                                              <Row>
                                                  <Col className="text-left px-24">
                                                      <div>
                                                          <input type="submit" value = "同意してログインする" title = "同意してログインする" className="btn-doc-Agree" disabled={isDisabled} onClick={() => handleCreateSubscription()}/>
                                                      </div>
                                                  </Col>
                                              </Row>
                                          </Grid>
                                      </Card>
                                  </Col>
                                  <Col></Col>
                              </Row>
                          </Grid>
                      </div>
                  </section>
              </main>
              <br />
              <footer className="App-header pt-48">
                  <McAfeeFooter />
              </footer>
            </div>
      </>
    )
  }
